<span
  class="skeleton-block"
  [class.skeleton-block--radius-bar]="radius() === 'bar'"
  [class.skeleton-block--radius-card]="radius() === 'card'"
  [class.skeleton-block--radius-shell]="radius() === 'shell'"
  [class.skeleton-block--radius-stub]="radius() === 'stub'"
  [class.skeleton-block--radius-circle]="radius() === 'circle'"
  [class.skeleton-block--tone-base]="tone() === 'base'"
  [class.skeleton-block--tone-secondary]="tone() === 'secondary'"
  [class.skeleton-block--tone-emphasis]="tone() === 'emphasis'"
  [class.skeleton-block--static]="!animated()"
  [style.width]="widthStyle()"
  [style.height]="heightStyle()"
></span>
